import React, { PropTypes } from 'react';

import './PageContent.scss';

const PageContent = props => (
  <div className="page-content container">{props.children}</div>
);

export default PageContent;
